import { FC, useState } from 'react'

import Chevron from '@/components/svg/Chevron'
import { NavigationItem } from '@/lib/navigationLinks'
import { cn } from '@/lib/utils'
import LinkWithQuery from '@/components/LinkWithQuery'

type Props = {} & NavigationItem

const MobileNavMenu: FC<Props> = ({ label, path, menuItems }) => {
  const [open, setOpen] = useState(false)

  return (
    <div className="w-full text-left text-black ">
      <div className="flex items-center justify-start w-full whitespace-nowrap">
        <LinkWithQuery href={path} prefetch={false} className="w-full">
          {label}
        </LinkWithQuery>
        {menuItems.length !== 0 && (
          <button onClick={() => setOpen((prev) => !prev)} className="p-4">
            <Chevron
              aria-label="chevron arrow down"
              direction={open ? 'up' : 'down'}
              className="text-neutral-400"
              height={20}
              width={25}
            />
          </button>
        )}
      </div>
      <div
        className={cn(
          'flex-col bg-white text-black w-full gap-4 px-8 pt-4',
          'laptop:max-w-56',
          open ? 'flex' : 'hidden',
        )}
      >
        {menuItems.map((item) =>
          item.subMenuItems ? (
            <MobileNavMenu
              key={item.label}
              label={item.label}
              path={item.path}
              menuItems={item.subMenuItems}
            />
          ) : item.external ? (
            <a
              key={item.label}
              href={item.path}
              target="_blank"
              rel="noreferrer"
              className="flex items-center h-13 py-4 hover:bg-red-torch"
            >
              {item.label}
            </a>
          ) : (
            <LinkWithQuery
              key={item.label}
              href={item.path}
              className="flex items-center h-13 py-4 hover:bg-red-torch"
            >
              {item.label}
            </LinkWithQuery>
          ),
        )}
      </div>
    </div>
  )
}

export default MobileNavMenu
